enum InstanceType {
  Api = '/api/v1',
}

export default InstanceType;
